import { Injectable } from '@angular/core';
import { Config } from 'ionic-angular';

import { Cognito } from './aws.cognito';

declare var AWS: any;
declare const aws_cognito_region;
declare const aws_cognito_identity_pool_id;
declare const aws_user_pools_id;
declare const aws_user_pools_web_client_id;

@Injectable()
export class User {

  private user: any;
  public loggedIn: boolean = false;
  public changeTempPw: boolean = false;
  public UserAttributes:any; 
  public RequiredAttributes:any;

  constructor(public cognito: Cognito, public config: Config) {
    this.user = null;
  }

  getUser() {
    return this.user;
  }

  getUsername() {
    return this.getUser().getUsername();
  }

  login(username, password) {
    return new Promise((resolve, reject) => {
      let user = this.cognito.makeUser(username);
      let authDetails = this.cognito.makeAuthDetails(username, password);

      user.authenticateUser(authDetails, {
        'onSuccess': (result:any) => {

          var logins = {};
          var loginKey = 'cognito-idp.' +
                          aws_cognito_region +
                          '.amazonaws.com/' +
                          aws_user_pools_id;
          logins[loginKey] = result.getIdToken().getJwtToken();

          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
           'IdentityPoolId': aws_cognito_identity_pool_id,
           'Logins': logins
          });

          AWS.config.credentials.get((err) => {
            if (err) {
              return reject(err);
            }

            this.isAuthenticated().then(() => {
              //let aKey = AWS.config.credentials;//.accessKeyId;
              //let cKey = AWS.config.credentials.secretKey;
              resolve();
            }).catch((err) => {
              console.log('auth session failed');
            });
          });
          
        },

        'onFailure': (err:any) => {

          console.log('authentication failed');
          reject(err);

        },
        'newPasswordRequired': (userAttributes, requiredAttributes ) => {
          //resolve(this.newPasswordRequired(userAttributes, requiredAttributes,"Temp Password"));
          user['challengeName'] = 'NEW_PASSWORD_REQUIRED';
                    user['challengeParam'] = {
                        userAttributes: userAttributes,
                        requiredAttributes: requiredAttributes
                    };
                    resolve(user);
                    
        }
      });
    });
  }

  logout() {
    this.user = null;
    this.cognito.getUserPool().getCurrentUser().signOut();
    AWS.config.credentials.clearCachedId();
  }

  register(username, password, attr) {
    let attributes = [];

    for (var x in attr) {
      attributes.push(this.cognito.makeAttribute(x, attr[x]));
    }

    return new Promise((resolve, reject) => {
      this.cognito.getUserPool().signUp(username, password, attributes, null, function(err, result) {
        if (err) {
          reject(err);
        } else {
          resolve(result.user);
        }
      });
    });
  }

  confirmRegistration(username, code) {
    return new Promise((resolve, reject) => {
      let user = this.cognito.makeUser(username);
      user.confirmRegistration(code, true, (err, result) => {
            if (err) {
              console.log('could not confirm user', err);
              reject(err);
            } else {
              resolve(result);
            }
        });
    });
  }

  resendRegistrationCode(username) {
    return new Promise((resolve, reject) => {
      let user = this.cognito.makeUser(username);
      user.resendConfirmationCode((err, result) => {
        if (err) {
          console.log('could not resend code..', err);
          reject(err);
        } else {
          resolve();
        }
      });
    });
  }

  isAuthenticated() {
    return new Promise((resolve, reject) => {
      let user = this.cognito.getCurrentUser();
      if (user != null) {
        user.getSession((err, session) => {
          if (err) {
            console.log('rejected session');
            reject()
          } else {
            console.log('accepted session');
            var logins = {};
            var loginKey = 'cognito-idp.' +
              aws_cognito_region +
              '.amazonaws.com/' +
              aws_user_pools_id;
            logins[loginKey] = session.getIdToken().getJwtToken();

            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
              'IdentityPoolId': aws_cognito_identity_pool_id,
              'Logins': logins
            });

            this.user = user;
            resolve()
          }
        });
      } else {
        reject()
      }
    });
  }

  resetPassword(username) {
    // const poolData = { UserPoolId: xxxx, ClientId: xxxx };
    // userPool is const userPool = new AWSCognito.CognitoUserPool(poolData);

    // setup cognitoUser first
    let cognitoUser = this.cognito.makeUser(username);

    // call forgotPassword on cognitoUser
    cognitoUser.forgotPassword({
        onSuccess: function(result) {
            console.log('call result: ' + result);
        },
        onFailure: function(err) {
            //alert(err);
        },
        /*inputVerificationCode() { // this is optional, and likely won't be implemented as in AWS's example (i.e, prompt to get info)
            var verificationCode = prompt('Please input verification code ', '');
            var newPassword = prompt('Enter new password ', '');
            cognitoUser.confirmPassword(verificationCode, newPassword, this);
        }*/
    });
  }

  // confirmPassword can be separately built out as follows...  
  confirmPassword(username, verificationCode, newPassword) {
    let cognitoUser = this.cognito.makeUser(username);

    return new Promise((resolve, reject) => {
        cognitoUser.confirmPassword(verificationCode, newPassword, {
            onFailure(err) {
                reject(err);
            },
            onSuccess() {
                resolve("Success");
            },
        });
    }); 
  }

  changeTempPassword(userData,tempPassword,newPassword){
    return new Promise((resolve, reject) => {
      //let user = this.cognito.makeUser(username);
      //this.user = user;
      this.completeNewPasswordChallenge(userData,newPassword,this.UserAttributes,{
        'onSuccess': (result:any) => {
          return resolve(result);
        },  
        'onFailure': (err:any) => {
        console.log('authentication failed');
        return reject(err);
        }
      }).then(() => {
        //let aKey = AWS.config.credentials;//.accessKeyId;
        //let cKey = AWS.config.credentials.secretKey;
        resolve();
      }).catch((err) => {
        console.log('auth session failed');
        alert("Error setting password!  Password must contain at least one upper case letter, at least one lowercase letter and at least one number.");
        //alert(err.message);
        return reject(err);
      });
    //this.changePassword(tempPassword,newPassword);
    //let authDetails = this.cognito.makeAuthDetails(username, password);

    });
  }

  changePassword(oldPassword,newPassword){
    //let user = this.cognito.getCurrentUser();
    //user.getSession();
    return new Promise((resolve, reject) => {
      this.user.changePassword(oldPassword,newPassword,function(err, result) {
        if (err) {
            alert(err);
            return reject(err);
        }
        console.log('call result: ' + result);
        return resolve(result);
      });
    });
  }

  newPasswordRequired(userAttributes, requiredAttributes,tempName){
    //alert('inNewPassword');
    //this.changeTempPw = true;
    let testr = "t";
    return new Promise((resolve, reject) => {
      this.UserAttributes = userAttributes; 
      this.RequiredAttributes = requiredAttributes;
      
      return resolve(tempName);
    });
  }

  completeNewPasswordChallenge(userData,newPassword, requiredAttributeData, callBack) {
    return new Promise((resolve,reject) => {
    if (!newPassword) {
      return reject('New password is required.');
    }
    //let user = this.cognito.makeUser(username);
    
      userData.completeNewPasswordChallenge(newPassword,requiredAttributeData,{
        'onSuccess': (result:any) => {
          return resolve(result);
        },  
        'onFailure': (err:any) => {
        console.log('authentication failed');
        return reject(err);
        }
      });
    });
  }


}



// WEBPACK FOOTER //
// ./src/providers/user.ts